import type { PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { EditUserFormFieldValues } from '../schema';

type IGenerateRequest = (
  formValues: EditUserFormFieldValues,
  isPhoneNumberFieldVisible: boolean
) => PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody;

/**
 * 利用者編集フォームの値から PUT API リクエストボディを生成する
 *
 * 電話番号フィールドが表示されているケース（isPhoneNumberFieldVisible。
 * logics/resolveFieldRequirements の判定結果）でのみ phone_number を送信する。
 * 空欄の場合は null を明示送信し、電話番号をクリアできるようにする。
 *
 * @param formValues - フォームの入力値
 * @param isPhoneNumberFieldVisible - 電話番号フィールドの表示可否
 * @returns PUT /partner_admins/users/:userId のリクエストボディ
 */
export const generateRequest: IGenerateRequest = (formValues, isPhoneNumberFieldVisible) => ({
  user: {
    full_name: formValues.fullName,
    email: formValues.email,
    ...(isPhoneNumberFieldVisible ? { phone_number: formValues.phoneNumber || null } : {}),
    external_user_id: formValues.externalUserId ?? '',
    ...(formValues.password ? { password: formValues.password } : {}),
    ...(formValues.password && formValues.passwordConfirmation
      ? { password_confirmation: formValues.passwordConfirmation }
      : {}),
    // billableFrom は Zod スキーマ（createEditUserFormSchema）で必須バリデーション済みかつ
    // .transform で Date 型に絞り込み済みのため、null 分岐は不要で常に送信する。
    billable_from: formatDate({ date: formValues.billableFrom, formatType: 'yyyy-MM-dd' }),
  },
});
